import React from 'react';
import Carousel from '../carousel/carousel';
import TableTd from './TableTd';



class Mantra33_canvas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            star: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            table: props.table
        }
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.table != this.props.table) {
            this.setState({ table: nextProps.table })
        }

    }
    render() {
        const { image, obj, count } = this.props;
        const { table, star } = this.state;
        let keys = Object.keys(table);
        return (
            <div>
                {/* <Carousel /> */}
                {/* <img src="/assets/img/home.png" className="img-fluid mantr6_img" alt="" /> */}
                <div className="container setdiv_canvas" id={"canvas_generate_" + this.props.module_name} >

                    <div className="canvas_33">
                        <div className="mantra33_upload_div">
                            <img src={image} className="img-fluid d-block mx-auto user_img" alt="" />
                            <img src="/assets/img/multistar.png" className="img-fluid multistar_img" alt="" />

                        </div>




                        <table className="table table-bordered table_class">
                            <thead>
                                <tr>
                                    <th className="serail_bg">No</th>
                                    <th className="parameter_bg">PARAMETERS</th>
                                    <th className="rating_bg">RATING</th>
                                </tr>
                            </thead>
                            <tbody>
                                {

                                    table['No'] && (table['No']).length > 0 && (table['No']).map((val, index1) => {

                                        return (
                                            <tr>
                                                <td>{table['No'][(index1)]}</td>
                                                <td>{table['PARAMETERS'][(index1)]}</td>
                                                <td>
                                                    <ul className={"star_rating star_" + (index1 + 1)}>
                                                        {
                                                            star && star.map((val, i) => {
                                                                let index = obj[index1] ? obj[index1] : '';
                                                                let classactive = '';
                                                                if (index) {
                                                                    if (index >= i) {
                                                                        classactive = 'active';
                                                                    }
                                                                }


                                                                return (
                                                                    <li className={classactive}>&nbsp;</li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </td>
                                            </tr>
                                        )
                                    })

                                }

                            </tbody>
                        </table>

                        <div className="total_score">
                            <h6>TOTAL SCORE <span>{count}</span>/100</h6>
                        </div>
                    </div>




                </div>

            </div>

        )
    }
}

export default Mantra33_canvas;